import React from 'react'

export default function Service() {
  return (
    <div className='service_page'>

    </div>
  )
}
